export const fieldsToSearch = [
    { key: 'supplierName', name: 'שם ספק' },
    { key: 'booknum', name: 'מספר חשבונית' },
    { key: 'amount', name: 'סכום' },
    { key: 'fromDate', name: 'מתאריך' },
    { key: 'toDate', name: 'עד תאריך' },
    { key: 'accountManager', name: 'מנהלת חשבונות' }
];